import * as React from "react";

export interface ITagBoxProps {
  tag: string;
  onClickDelete: () => void;
  onClickTag?: () => void;
}

export interface ITagBoxState {}

export default class TagBox extends React.Component<
  ITagBoxProps,
  ITagBoxState
> {
  constructor(props: ITagBoxProps) {
    super(props);
  }
  render() {
    return (
      <div style={{ display: "flex", marginLeft: "7px" }}>
        <div
          onClick={this.props.onClickTag}
          style={{ cursor: `${this.props.onClickTag ? "pointer" : ""}` }}
        >
          {this.props.tag}
        </div>
        <span
          onClick={this.props.onClickDelete}
          style={{ color: "#aaaaaa", cursor: "pointer" }}
        >
          &nbsp;x
        </span>
      </div>
    );
  }
}
